<template>
  <v-dialog 
    v-model="activeMode"  
    max-width="800"
    @click:outside="closeForm()"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    
    <template v-slot:activator="{ on }">
       <v-btn v-if="id" icon v-on="on">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      
      <v-btn v-else 
        fab 
        dark 
        small 
        color="primary"
        v-on="on"
      >
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </template>
    
    <v-card>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>{{ title }}</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon @click="closeForm()">
          <v-icon>mdi-close</v-icon>
        </v-btn>

      </v-toolbar>
      
      <v-card-text class="mt-7"><v-form ref="form" v-model="isValid">
      <v-row dense>
        <v-col cols="12" v-if="Boolean(serverError)">
          <v-alert 
            dense 
            outlined
            type="error" 
            transition="scale-transition"
          >
            {{ serverError }}
          </v-alert>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            label="Наименование *"
            v-model="material.name"
            filled
            @focus="serverError = false"
            :rules="[v => !!v || 'Введите название товара.']"
          ></v-text-field>
        </v-col><v-col cols="12" sm="6">
          <v-autocomplete
            label="Категория товара *"
            v-model="material.category"
            filled
            :rules="[v => !!v || 'Выберите категорию товара.']"
            :items="materialCategories"
            item-text="name"
            item-value="_id"
          ></v-autocomplete>
        </v-col><v-col cols="12" sm="6">
          <v-combobox
            label="Ед. измерения (сметная) *"
            v-model="material.unitName"
            :items="unitNames"
            clearable
            filled
            :rules="[v => !!v || 'Выберите ед. измерения.']"
            :disabled="isFixedUnitName"
          ></v-combobox>
        </v-col><v-col cols="12" sm="6">
          <v-combobox
            label="Ед. измерения (упаковка) *"
            v-model="material.productUnitName"
            :items="unitNames"
            clearable
            filled
            :rules="[v => !!v || 'Выберите ед. измерения.']"
          ></v-combobox>
        </v-col><v-col cols="12" sm="6">
          <v-text-field
            label="Размер упаковки (сметных ед. изм.) *"
            v-model="material.productUnitSize"
            filled
            :rules="[v => !!v || 'Введите размер упаковки.', v => isNumber(v) || 'Размер должен быть числом.']"
          ></v-text-field>
        </v-col><v-col cols="12" sm="6">
          <v-text-field
            label="Цена за ед. (упак.) *"
            v-model="material.pricePerUnit"
            filled
            :rules="[v => (v == '0') || !!v || 'Введите цену упаковки.', v => isNumber(v) || 'Цена должна быть числом.']"
            append-icon="mdi-currency-rub"
          ></v-text-field>
        </v-col><v-col cols="12" sm="6">
          <v-combobox
            label="Поставщик"
            v-model="material.shop"
            :items="materialShops"
            clearable
            filled
          ></v-combobox>
        </v-col><v-col cols="12" sm="6">
           <v-text-field
            label="Артикул поставщика"
            v-model="material.shopCode"
            filled
          ></v-text-field>
        </v-col><v-col cols="12" sm="6">
          <v-combobox
            label="Производитель"
            v-model="material.brand"
            :items="materialBrands"
            clearable
            filled
          ></v-combobox>
        </v-col><v-col cols="12" sm="6">
        </v-col><v-col cols="12">
          <v-textarea
            label="Описание товара"
            v-model="material.description"
            filled
          ></v-textarea>
        </v-col><v-col cols="12">
          <files-table 
            :key="componentId"
            label="Фотографии товара"
            v-model="material.photos" 
            @updateLoading="loadingPhotos = $event"
          ></files-table>
        </v-col>
      </v-row>
      </v-form></v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="blue darken-1" text @click="closeForm()">Закрыть</v-btn>

        <v-btn 
          color="blue darken-1" 
          text 
          @click="save()"
          :disabled="loadingPhotos"
        >Сохранить</v-btn>

      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'lodash';
import { mapGetters, mapState } from 'vuex';
import { getTempId } from '../../models/common';

export default {
  name: 'material-card',

  props: {
    id: String,
    category: String
  },

  data() {
    return {
      activeMode: false,
      isValid: false,
      title: this.id ? 'Карточка материала' : 'Создание материала',
      material: this.id ? 
        _.cloneDeep(this.$store.getters['prices/getMaterialById'](this.id)) : 
        this.setDefaultObj(),
      loadingPhotos: false,
      serverError: false,
      componentId: this.id ? this.id : getTempId()
    }
  },

  methods: {
    setDefaultObj() {
      return {
        name: '',
        productUnitName: 'шт', // Сметная ед.измерения (м2, кг и т.д.)
        unitName: this.category ? 
          this.$store.getters['prices/getMaterialCategoryById'](this.category).unitName : 
          '', // Товарная ед.измерения (мешок, упак и т.д.)
        productUnitSize: 1, // Кол-во Сметных ед. в 1-ой Товарной ед. измерения (например, мешок = 30 кг)
        pricePerUnit: 0,
        description: '', // Описание товара (HTML-формат?)
        photos: [],
        brand: '', // Производитель товара
        shop: '', // Поставщик товара
        shopCode: '',
        category: this.category ? this.category : null, // Категория товара (1 уровень)
      }
    },

    save() {
      this.$refs.form.validate();
      if (this.isValid) {
        try {
          if (this.id) this.$store.commit('prices/UPDATE_MATERIAL', this.material)
          else this.$store.commit('prices/CREATE_MATERIAL', this.material);
          this.$store.dispatch('showMessage', 'Материал успешно сохранен.');
          this.closeForm();
          this.componentId = this.id ? this.id : getTempId();
        } catch(err) {
          this.serverError = err.message;
          this.scrollUp();
        }
      }
    },

    closeForm() {
      this.scrollUp();
      this.activeMode = false;
      this.material = this.id ? 
        _.cloneDeep(this.$store.getters['prices/getMaterialById'](this.id)) : 
        this.setDefaultObj();
      this.$refs.form.resetValidation();
      this.serverError = false;
    }
  },

  watch: {
    ['material.category'](val) {
      if (val) {
        let category = this.materialCategories.find(x => x._id == this.material.category);
        if (category.unitName) {
          this.material.unitName = category.unitName;
        }
      }
    }
  },

  computed: {
    ...mapGetters('prices', ['materialCategories', 'unitNames', 'materialBrands', 'materialShops']),
    isFixedUnitName() {
      let category = this.materialCategories.find(x => x._id == this.material.category);
      if (category) {
        return Boolean(category.unitName);
      } else {
        return false;
      }
    }
  }
}
</script>